"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ErrorMessageWrap = styled_components_1.default.div(({ theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    color: colors.error,
}));
function ErrorMessage(props) {
    const { className, error, getMessage = e => String(e) } = props;
    if (!error)
        return null;
    return (react_1.default.createElement(ErrorMessageWrap, { className: `error ${className || ''}`, role: "alert", "data-id": "error-message" }, getMessage(error)));
}
exports.default = ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map